// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","executivesList":"_23xP0tlqGq1w3ZDlGD1BUX"};